var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.814,
    height: 13.996,
    viewBox: "0 0 9.814 13.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "female",
    transform: "translate(-87.111 -15.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M21281.887,6150h-1.742v-1.261h-1.271V6147h1.271v-1.261a4.91,4.91,0,1,1,1.742,0V6147h1.275v1.742h-1.275V6150Zm-.871-12.255a3.163,3.163,0,1,0,3.168,3.163A3.166,3.166,0,0,0,21281.016,6137.743Z",
    transform: "translate(-21189 -6121)",
    fill: "#d1131d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleColor);
export default __webpack_public_path__ + "static/media/female-color.85fa619658d0f019dadc819593ac7210.svg";
export { ForwardRef as ReactComponent };